<template>
  <div class="presentationBox" @click="toExhibitInfo(presentationData)">
    <img class="presentationShowImg" :src="presentationData.showImg" alt="" />
    <img
      class="exhibit-arrow-hover"
      v-if="isIndex"
      src="@/assets/rightArr_gery.png"
      alt=""
    />
    <div class="pre-title" v-if="!isIndex">
      {{
        lan
          ? presentationData.activityEnTitle
          : presentationData.activityCnTitle
      }}
    </div>
    <div class="pre-sub-title" v-if="!isIndex">
      {{
        lan
          ? presentationData.activityEnSubTitle
          : presentationData.activityCnSubTitle
      }}
    </div>
    <div
      class="pre-time"
      v-if="presentationData.startDate && !isIndex"
    >
      {{ formatActivityDate(presentationData.startDate, presentationData.endDate) }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    presentationData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isIndex: false,
      lan: this.$store.state.isEn,
      isBackNavigation: false,
      pendingScrollPosition: null, // 存储待恢复的滚动位置
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  created() {
    // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  // 使用 activated 钩子，适用于 keep-alive 组件
  activated() {
    // 只有在非返回操作时才恢复滚动位置
    if (!this.isBackNavigation) {
      this.restoreScrollPosition();
    } else {
      // 如果是返回操作，设置标记并在下一次 DOM 更新后恢复滚动
      this.isBackNavigation = false;
      this.$nextTick(() => {
        this.restoreScrollPosition();
      });
    }
  },
  mounted() {
    // 页面加载完成后恢复滚动位置
    // 只有在非返回操作时才恢复滚动位置
    if (!this.isBackNavigation) {
      this.restoreScrollPosition();
    } else {
      // 如果是返回操作，设置标记并在下一次 DOM 更新后恢复滚动
      this.isBackNavigation = false;
      this.$nextTick(() => {
        this.restoreScrollPosition();
      });
    }

    // 监听页面可见性变化
    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    // 监听浏览器前进后退按钮
    window.addEventListener("popstate", this.handlePopState);
  },
  beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    window.removeEventListener("popstate", this.handlePopState);
  },
  methods: {
    handleMediaQueryChange(event) {
      // 简化媒体查询处理逻辑
      this.isIndex = !event.matches;
    },
    // 保存滚动位置
    saveScrollPosition() {
      try {
        // 保存当前页面的滚动位置
        const scrollPosition = {
          x: window.pageXOffset || document.documentElement.scrollLeft,
          y: window.pageYOffset || document.documentElement.scrollTop,
        };

        // 将滚动位置保存到 sessionStorage 中，使用当前路由作为 key
        const key = `scrollPosition_${this.$route.fullPath}`;
        sessionStorage.setItem(key, JSON.stringify(scrollPosition));
      } catch (error) {
      }
    },

    // 恢复滚动位置
    restoreScrollPosition() {
      try {
        // 使用当前路由作为 key 从 sessionStorage 中获取保存的滚动位置
        const key = `scrollPosition_${this.$route.fullPath}`;
        const savedPosition = sessionStorage.getItem(key);

        if (savedPosition) {
          const position = JSON.parse(savedPosition);
          // 直接执行滚动（presentationBox是组件，滚动位置应该保存在父页面）
          this.executeScroll(position);
        }
      } catch (error) {
        console.error("恢复滚动位置失败:", error);
      }
    },

    // 执行滚动操作
    executeScroll(position) {
      this.$nextTick(() => {
        // 添加额外的延迟确保页面完全渲染
        setTimeout(() => {
          try {
            window.scrollTo({
              top: position.y,
              left: position.x,
              behavior: "auto",
            });
          } catch (error) {
          }
        }, 100);
      });
    },

    // 处理页面可见性变化
    handleVisibilityChange() {
      if (!document.hidden) {
        // 页面变为可见时恢复滚动位置
        this.restoreScrollPosition();
      }
    },

    // 处理浏览器前进后退按钮
    handlePopState(event) {
      this.isBackNavigation = true;
      // 在下一个事件循环中恢复滚动位置
      this.$nextTick(() => {
        setTimeout(() => {
          this.restoreScrollPosition();
        }, 100);
      });
    },
    
    // 格式化活动日期显示
    formatActivityDate(startDate, endDate) {
      // 如果没有结束日期或者开始日期和结束日期相同，则只显示开始日期
      if (!endDate || startDate === endDate) {
        return startDate || '';
      }
      // 否则显示日期范围格式
      return `${startDate || ''}-${endDate || ''}`;
    },
    
    toExhibitInfo(e) {
      // 标记这不是返回操作
      this.isBackNavigation = false;

      // 在跳转前保存当前滚动位置
      this.saveScrollPosition();

      if (e.link) {
        window.open(e.link, '_blank');
      } else {
        this.$router.push({
          path: "/activityPage/activityListInfo",
          query: {
            columnId: 35,
            id: e.id,
            activityType: e.activityType,
          },
        }).catch(err => {
          // 添加路由错误处理，避免NavigationDuplicated错误
          if (err.name !== "NavigationDuplicated") {
            console.error("Routing error:", err);
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.presentationBox {
  width: 708px;
  margin-bottom: 60px;
  cursor: pointer;
}
.presentationShowImg {
  width: 708px;
  height: 456px;
  object-fit: cover;
  cursor: pointer;
}
.pre-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 36px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: Bold;
  margin: 16px 0 8px;
}
.pre-sub-title {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: Regular;
}
.pre-time {
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  font-weight: Regular;
  margin: 8px 0;
}
@media (max-width: 1480px) {
  .presentationBox {
    position: relative;
    width: 45%;
    max-height: 420;
    height: auto;
    cursor: pointer;
    margin: 0 20px 30px;
  }
  .presentationShowImg {
    max-width: 100%;
    max-height: 420;
    height: auto;
    object-fit: cover;
    cursor: pointer;
  }
  .exhibit-arrow-hover {
    width: 30px;
    height: 23px;
    position: absolute;
    top: 20px;
    right: 25px;
  }
  .pre-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 29px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
    margin: 12px 0 8px;
  }
  .pre-sub-title {
    font-family: SourceHanSansCN-Regular;
    font-size: 15px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
  }
  .pre-time {
    font-family: SourceHanSansCN-Regular;
    font-size: 13px;
    color: #98989f;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
    margin: 4px 0;
  }
}
@media (max-width: 960px) {
  .presentationBox {
    position: relative;
    width: 99%;
    cursor: pointer;
    margin: 0 20px 30px;
  }
  .presentationShowImg {
    width: 100%;
    height: auto;
    object-fit: contain;
    cursor: pointer;
  }
  .exhibit-arrow-hover {
    width: 30px;
    height: 18px;
    position: absolute;
    top: 20px;
    right: 20px;
  }
}
</style>